import React, { useRef, useState, useEffect } from "react";
import axios from "axios";

import "react-datepicker/dist/react-datepicker.css";
import "./Dashboard.css";
import bill from "../../image/bill.png";
import time from "../../image/time.png";
import rate from "../../image/rate.png";
import activity from "../../image/activity.png";
import menuIcon from "../../image/menu-icon.png";
import SideBar from "../SideBar/SideBar";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import Footer from "../Footer/Footer";
import Config from "../../utils/Config";
import { Portal } from "react-overlays";

// Import the chart components
import {
  StepDataChart,
  WeightChart,
  WeightChartWithings,
  HeartRateChart,
  WeeklyActivityTrendChart,
  ComplianceByDayChart,
  BillingReadinessChart,
  StepsVsHeartRateChart,
} from "../Charts";

function getCurrentMonthTotalDays() {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();
  const totalDays = new Date(currentYear, currentMonth + 1, 0).getDate();

  return totalDays;
}

async function setPageStartTime() {
  localStorage.setItem("startTime", new Date());
  return "done";
}

const Dashboard = () => {
  const totalDaysInCurrentMonth = getCurrentMonthTotalDays();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [patients, setPatients] = useState([]);
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [previousPatientId, setPreviousPatientId] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState([0]);
  const [startTime, setStartTime] = useState(new Date());
  const [percentOfTwentyMinutes, setPercentOfTwentyMinutes] = useState(0);
  const [percentOfSteps, setPercentOfSteps] = useState(0);
  const [user, setUser] = useState({});
  const [checkedCustomReport, setCheckedCustomReport] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [hasWeight, setHasWeight] = useState(false);
  const [hasWeightWithings, setHasWeightWithings] = useState(false);
  const [hasHr, setHasHr] = useState(false);
  const [hasSteps, setHasSteps] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const pageClickRef = useRef();

  localStorage.setItem("leftPage", "0");

  const notifyError = (text) => toast.error(text);

  const CalendarContainer = ({ children }) => {
    const el = document.getElementById("calendar-portal");
    return <Portal container={el}>{children}</Portal>;
  };

  useEffect(() => {
    if (
      typeof user.features !== "undefined" &&
      typeof selectedPatient.full_name !== "undefined"
    ) {
      updateChartFlags(selectedPatient, user);
    }
  }, [user, selectedPatient]);

  // Helper function to update chart flags
  const updateChartFlags = (patient, user) => {
    if (
      patient.month_steps &&
      patient.month_steps[3] &&
      patient.month_steps[3].length > 3 &&
      user.features.includes("heart_rate")) {
      setHasHr(true);
    }
    if (patient.month_steps &&
        patient.month_steps[6] &&
        patient.month_steps[6].length > 0) {
        
          if(patient.account_id == "8") {
            setHasWeight(false);
            setHasWeightWithings(true);
          }
          else if (patient.account_id == "6") {
            setHasWeight(true);
            setHasWeightWithings(false);
          }
          else {
            setHasWeight(true);
            setHasWeightWithings(false);
          }
      }
    if (
      patient.month_steps[0] &&
      patient.month_steps[1].length > 3 &&
      user.features.includes("steps")) {
      setHasSteps(true);
    }
    // if (patient.month_steps &&
    //   patient.month_steps[8] &&
    //   patient.month_steps[8].length > 0 &&
    //   user.features.includes("weightWithings")) {
    //   setHasWeightWithings(true);
    //   setHasWeight(false);
    // }
  };

  useEffect(() => {
    setPageStartTime();
    localStorage.setItem("leftPage", "0");

    window.onclick = (event) => {
      if (
        event.target.contains(pageClickRef.current) &&
        event.target !== pageClickRef.current
      ) {
      } else {
        localStorage.setItem("leftPage", "0");
      }
    };

    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${Config.API_URL}/data/all_patients`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = JSON.parse(response.data);

        setIsLoading(false);
        if (data !== null) {
          setPatients(data);
          // console.log(data)

          for (let i = 0; i < data.length; i++) {
            if (
              data[i]["full_name"] === localStorage.getItem("SelectedPatient")
            ) {
              handleSelectPatient(data[i], user);
              break;
            }
          }
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          navigate("/login");
        }
      }

      setIsLoading(false);
    };

    const fetchUser = async () => {
      try {
        const response = await axios.get(`${Config.API_URL}/profile`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setUser(response.data);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          navigate("/login");
        } else {
          notifyError(error.response.data.detail);
        }
      }
    };

    fetchUser();
    fetchData();

    const mouseHandler = (event) => {
      localStorage.setItem("leftPage", "0");
    };

    if (window.location.href.includes("dashboard")) {
      window.addEventListener("beforeunload", (event) => {
        handleSwitch();
      });
      window.addEventListener("pagehide", (event) => {
        handleSwitch();
      });
      document.addEventListener("visibilitychange", (event) => {
        handleSwitch();
      });

      window.addEventListener("unload", (event) => {
        handleSwitch();
      });

      document.addEventListener("mousedown", mouseHandler);
    }

    if (!window.location.href.includes("dashboard")) {
      window.removeEventListener("beforeunload", (event) => {
        handleSwitch();
      });
      window.removeEventListener("pagehide", (event) => {
        handleSwitch();
      });

      document.removeEventListener("visibilitychange", (event) => {
        handleSwitch();
      });

      window.removeEventListener("unload", (event) => {
        handleSwitch();
      });

      document.removeEventListener("mousedown", mouseHandler);
    }

    return () => {
      window.removeEventListener("beforeunload", (event) => {
        handleSwitch();
      });

      window.removeEventListener("pagehide", (event) => {
        handleSwitch();
      });

      document.removeEventListener("visibilitychange", (event) => {
        handleSwitch();
      });

      window.removeEventListener("unload", (event) => {
        handleSwitch();
      });

      document.removeEventListener("mousedown", mouseHandler);
    };
  }, [token, navigate]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSwitch = async () => {
    let leftPage = "-1";

    leftPage = localStorage.getItem("leftPage");

    if (window.location.href.includes("dashboard") && leftPage === "0") {
      localStorage.setItem("leftPage", 1);
      let startTime = localStorage.getItem("startTime");
      let endTime = new Date();
      localStorage.setItem("endTime", endTime);
      const token = localStorage.getItem("token");

      let timeSpent = endTime - Date.parse(startTime);

      let hours = Math.floor(timeSpent / (1000 * 60 * 60));
      let minutes = Math.floor((timeSpent % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((timeSpent % (1000 * 60)) / 1000);

      if (minutes > 20) {
        minutes = 20;
      }

      if (hours > 0) {
        hours = 0;
      }

      let formData = new FormData();
      formData.append("id", localStorage.getItem("previousPatientID"));
      formData.append("hours", parseInt(hours));
      formData.append("mins", parseInt(minutes));
      formData.append("sec", parseInt(seconds));

      try {
        await axios
          .post(`${Config.API_URL}/set_reviewing_time`, formData, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            //toast.success("Saved reviewing time")
          })
          .catch((error) => {
            toast.error(error.response.data.detail);
          });
      } catch (error) {
        toast.error("Error saving reviewing time");
      }

      setPageStartTime();
    }
  };

  const handleSearchInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    filterPatients(query);
    setShowDropdown(query !== "");
  };

  const filterPatients = (query) => {
    const filtered = patients.filter((patient) =>
      patient.full_name.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredPatients(filtered);
  };

  const listAllPatients = async () => {
    try {
      const response = await axios.post(
        `${Config.API_URL}/data/list_patients`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      let data = JSON.parse(response.data);
    } catch (error) {
      notifyError(error.response.data.detail);
    }
  };

  const handleRemovePatient = async (patientId) => {
    let agree = false;

    setIsRemoving(true);
    const response = window.confirm(
      "Are you sure you want to remove that patient?"
    );
    if (response) {
      agree = true;
    } else {
      toast.error("Cancelled");
    }

    if (agree) {
      let formData = new FormData();
      formData.append("id", patientId);

      await axios({
        method: "POST",
        url: `${Config.API_URL}/remove_patient`,
        data: JSON.stringify({ value: [patientId] }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          toast.success("Successfully removed patient");
          navigate("/table");
        })
        .catch((error) => {
          notifyError(error.response.data.detail);
        });
      setPreviousPatientId("");
      localStorage.setItem("previousPatientID", "");
    }
    setIsRemoving(false);
  };

  const handleBillingReport = async (patientId) => {
    setIsGenerating(true);
    await axios({
      method: "POST",
      url: `${Config.API_URL}/generate_report`,
      data: JSON.stringify({
        value: [patientId, token, checkedCustomReport, startDate, endDate],
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        toast.success("Check your email for the report!");
      })
      .catch((error) => {
        notifyError(error.response.data.detail);
      });

    setIsGenerating(false);
  };

  const handleSelectPatient = (patient, user) => {
    setSearchQuery(patient.full_name);
    setSelectedPatient(patient);
    let totalSeconds =
      patient.reviewing_time.hours * 3600 +
      patient.reviewing_time.minutes * 60 +
      patient.reviewing_time.seconds;
    setPercentOfTwentyMinutes((totalSeconds / 1200) * 100);
    setPercentOfSteps((patient.steps / 5000) * 100);
    setStartTime(new Date());
    localStorage.setItem("startTime", startTime);
    localStorage.setItem("SelectedPatient", patient.full_name);

    console.log(patient.month_steps)

    // console.log(patient.account_id)

    // Check if heart rate and weight data are available
    if (
      typeof user.features !== "undefined" &&
      patient.month_steps &&
      patient.month_steps.length >= 4
    ) {
      if (
      patient.month_steps[0] &&
      patient.month_steps[1].length > 3 &&
      user.features.includes("steps")) {
      setHasSteps(true);
      }
      if (
        patient.month_steps &&
        patient.month_steps[3] &&
        patient.month_steps[3].length > 3 &&
        user.features.includes("heart_rate")) {
        setHasHr(true);
      }
      if (patient.month_steps &&
        patient.month_steps[6] &&
        patient.month_steps[6].length > 0) {
        
          if(patient.account_id === "8") {
            //withings id
            setHasWeight(false);
            setHasWeightWithings(true);
          }
          else if (patient.account_id === "6") {
            //fitbit id
            setHasWeight(true);
            setHasWeightWithings(false);
          }
          else {
            //google health id
            setHasWeight(true);
            setHasWeightWithings(false);
          }
      }
      // if (patient.month_steps &&
      //   patient.month_steps[8] &&
      //   patient.month_steps[8].length > 0 &&
      //   user.features.includes("weightWithings")) {
      //   setHasWeightWithings(true);
      //   setHasWeight(false);
      // }
    }

    setFilteredPatients([]);
    setPreviousPatientId(patient.id);
    setSearchQuery("");
    setShowDropdown(false);
    localStorage.setItem("previousPatientID", patient.id);
  };

  const [toggle, setToggle] = useState(false);
  const handleToggle = () => {
    setToggle(!toggle);
  };

  return (
    <div>
      <div>
        <div ref={pageClickRef} className="container-fluid">
          <Toaster position="top-center" reverseOrder={false} />

          {isLoading ? (
            <div className="loading">Loading...</div>
          ) : patients.length > 0 ? (
            <div>
              <div className="top_part">
                <div className="mobile_menu" onClick={handleToggle}>
                  <img src={menuIcon} alt="menu icon" />
                  <SideBar toggle={toggle} />
                </div>
                <div className="practice_name">
                  <div className="right_info">
                    <div>
                      <b>{user.practice_name}</b>
                    </div>
                  </div>
                </div>
                
                <div className="row align-items-center">
                  <div className="col-6">
                    <div className="search_form">
                      <input
                        type="text"
                        placeholder="Search for a patient..."
                        value={searchQuery}
                        onChange={handleSearchInputChange}
                      />
                      {showDropdown && filteredPatients.length > 0 && (
                        <ul className="dropdown-menu1">
                          {filteredPatients.map((patient) => (
                            <li
                              key={patient.id}
                              onClick={() => handleSelectPatient(patient, user)}
                              className="dropdown-item"
                            >
                              {patient.full_name}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>

              </div>
              <div className="DashboardHead">
                <div>
                  <h2>{selectedPatient.full_name}</h2>
                </div>
                <div style={{ display: "flex" }}>
                  <button
                    className="Dashboard_button"
                    type="submit"
                    onClick={() => handleRemovePatient(previousPatientId)}
                  >
                    {isRemoving ? <>Removing...</> : <>Remove Patient</>}
                  </button>
                  <button
                    className="Dashboard_button"
                    type="submit"
                    onClick={() => handleBillingReport(previousPatientId)}
                  >
                    {isGenerating ? <>Generating...</> : <>Generate Report</>}
                  </button>
                </div>
                <div className="customReport">
                  <div className="row">
                    <div className="col-md-6 col-lg-3">
                      <div className="row">
                        <div className="col-md-6 col-lg-3">
                          <div className="check_box_custom">
                            <input
                              style={{ width: 16, height: 16 }}
                              type="checkbox"
                              id="customReport"
                              name="customReport"
                              checked={checkedCustomReport}
                              onChange={() =>
                                setCheckedCustomReport(!checkedCustomReport)
                              }
                            />
                          </div>
                        </div>
                        <div
                          className="col-md-6 col-lg-3"
                          style={{ marginLeft: "10px" }}
                        >
                          <label>Custom Report</label>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-md-6 col-lg-3"
                      style={{ marginLeft: "20px" }}
                    >
                      &nbsp; Start:
                      <DatePicker
                        wrapperClassName="datePicker"
                        popperContainer={CalendarContainer}
                        selected={startDate}
                        placeholderText="Start"
                        onChange={(date) => setStartDate(date)}
                      />
                    </div>
                    <div
                      className="col-md-6 col-lg-3"
                      style={{ marginLeft: "20px" }}
                    >
                      &nbsp; End:
                      <DatePicker
                        wrapperClassName="datePicker"
                        popperContainer={CalendarContainer}
                        selected={endDate}
                        placeholderText="End"
                        onChange={(date) => setEndDate(date)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="calculated_value">
                <div className="row">
                  <div className="col-md-6 col-lg-3">
                    <div className="time">
                      <p>Time spent reviewing</p>
                      <div className="timeData">
                        <div>
                          <img src={time} alt="Time" />
                        </div>
                        {selectedPatient.reviewing_time && (
                          <h6>
                            {selectedPatient.reviewing_time.hours > 9
                              ? selectedPatient.reviewing_time.hours
                              : "0" + selectedPatient.reviewing_time.hours}
                            :
                            {selectedPatient.reviewing_time.minutes > 9
                              ? selectedPatient.reviewing_time.minutes
                              : "0" + selectedPatient.reviewing_time.minutes}
                          </h6>
                        )}
                      </div>
                      <div className="progress">
                        <div
                          className="progress-bar bg-success"
                          role="progressbar"
                          style={{
                            width: `${percentOfTwentyMinutes}%`,
                            borderRadius: "10px",
                          }}
                          aria-valuenow="0"
                          aria-valuemin="0"
                          aria-valuemax="1200"
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="time">
                      <p>Today's Activity</p>
                      <div className="timeData">
                        <div>
                          <img src={activity} alt="activity" />
                        </div>
                        <h6>{selectedPatient.steps} Steps</h6>
                      </div>
                      <div className="progress">
                        <div
                          className="progress-bar bg-warning"
                          role="progressbar"
                          style={{
                            width: `${percentOfSteps}%`,
                            borderRadius: "10px",
                          }}
                          aria-valuenow="0"
                          aria-valuemin="0"
                          aria-valuemax="5000"
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="time">
                      <p>Compliance rate</p>
                      <div className="timeData">
                        <div>
                          <img src={rate} alt="rate" />
                        </div>
                        <h6>{selectedPatient.compliance_rate} %</h6>
                      </div>
                      <div className="progress">
                        <div
                          className="progress-bar bg-primary"
                          role="progressbar"
                          style={{
                            width: selectedPatient.compliance_rate + "%",
                            borderRadius: "10px",
                          }}
                          aria-valuenow="55"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="time">
                      <p>Billing</p>
                      <div className="timeData">
                        <div>
                          <img src={bill} alt="Bill" />
                        </div>
                        <h6>
                          {selectedPatient.billing > 0
                            ? selectedPatient.billing
                            : "0"}
                          /{totalDaysInCurrentMonth} days
                        </h6>
                      </div>
                      <div className="progress">
                        <div
                          className="progress-bar bg-info"
                          role="progressbar"
                          style={{
                            width: selectedPatient.billing + "%",
                            borderRadius: "10px",
                          }}
                          aria-valuenow="55"
                          aria-valuemin="0"
                          aria-valuemax={totalDaysInCurrentMonth}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* CHART COMPONENTS */}

              {/* Step Data Chart */}
              { hasSteps ? 
              (<StepDataChart patientData={selectedPatient} hasSteps={hasSteps}/>) : (<div></div>)
              }

              <div>
                <br></br>
              </div>

              {/* Heart Rate Chart */}
              <HeartRateChart patientData={selectedPatient} hasHr={hasHr} />

              <div>
                <br></br>
              </div>

              {/* Weight Chart */}
              <WeightChart
                patientData={selectedPatient}
                hasWeight={hasWeight}
              />

              <div>
                <br></br>
              </div>

              {/* Weight Chart Withings */}
              <WeightChartWithings
                patientData={selectedPatient}
                hasWeightWithings={hasWeightWithings}
              />

              <div>
                <br></br>
              </div>

              {/* Weekly Activity Trend Chart */}
              <WeeklyActivityTrendChart patientData={selectedPatient} />

              <div>
                <br></br>
              </div>

              {/* Compliance Charts */}
              <div className="row">
                <div className="col-md-6">
                  <ComplianceByDayChart patientData={selectedPatient} />
                </div>
                <div className="col-md-6">
                  <BillingReadinessChart patientData={selectedPatient} />
                </div>
              </div>

              <div>
                <br></br>
              </div>

              {/* Steps vs Heart Rate Chart */}
              <StepsVsHeartRateChart
                patientData={selectedPatient}
                hasHr={hasHr}
              />

              <div>
                <br></br>
              </div>
            </div>
          ) : (
            <div></div>
          )}
        </div>
      </div>

      <div>
        <div className="container-fluid">
          <Toaster position="top-center" reverseOrder={false} />

          {isLoading ? (
            <div></div>
          ) : patients.length > 0 ? (
            <div>
              <div className="DashboardHead"></div>
              <Footer />
            </div>
          ) : (
            <div style={{ paddingTop: "10px" }}>
              <h2>
                Start tracking by{" "}
                <Link to={"/add_fitbit"}>adding a Fitbit Patient</Link>
              </h2>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
